import { observer } from "mobx-react-lite";
import React from "react";
import { StyleSheet } from "react-native";
import { ButtonV2 } from "~/components/V2/Button";
import { View } from "~/components/V2/View";

const S = StyleSheet.create({
  button: {
    paddingHorizontal: 32,
  },
});

export const SaveButton = observer(function SaveButton({
  onPress,
}: {
  onPress: () => Promise<void>;
}) {
  return (
    <>
      <View centerContent>
        <ButtonV2
          medium
          primaryReversed
          title={intl.formatMessage({
            id: "+itf/D",
            defaultMessage: "Save",
            description: "Save button",
          })}
          textStyle={{
            fontFamily: "DMSans-Bold",
          }}
          style={S.button}
          onPress={onPress}
        />
      </View>
    </>
  );
});
